module.exports = __webpack_public_path__ + "static/media/ESTATUTO-ABMR-CARTORIO.1bd1a178.pdf";